var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-25 -25 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr-simple",
    x1: 0,
    y1: 0,
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,.2)",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,255,255,.7)",
    offset: "90%"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26,
    cy: 27,
    r: 26,
    stroke: "url(#gr-simple)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,0A24.92,24.92,0,0,1,42.68,7.32",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1s",
    from: "0 26 27",
    to: "360 26 27",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.db8af8faf7dc09da65a120e21ebfe0b8.svg";
export { ForwardRef as ReactComponent };